<template>
<div>
    <div class="md-layout">

        <div @click="carros()" class="md-layout-item md-medium-size-30 md-xsmall-size-100 md-size-30">
            <stats-card header-color="primary">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-car"></i>
                    </div>
                    <h4 class="title">
                        LIMITES
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        <span>Click para abrir</span>
                    </div>
                </template>
            </stats-card>
        </div>

        <div @click="relatorio()" class="md-layout-item md-medium-size-35 md-xsmall-size-100 md-size-35">
            <stats-card header-color="green">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-file-invoice-dollar"></i>
                    </div>
                    <h4 class="title">
                        RELATÓRIOS
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        <span>Click para abrir</span>
                    </div>
                </template>
            </stats-card>
        </div>

        <div @click="postos()" class="md-layout-item md-medium-size-35 md-xsmall-size-100 md-size-35">
            <stats-card header-color="warning">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-gas-pump"></i>
                    </div>
                    <h4 class="title">
                        POSTOS CREDENCIADOS
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        <span>Click para abrir</span>
                    </div>
                </template>
            </stats-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    StatsCard,
    AnimatedNumber
} from "@/components";
import Notify from '@/config/mixins/notify'

export default {
    components: {
        StatsCard
    },

    data() {
        return {
            homeCliente: {},
            carregado: false
        };
    },

    created() {

    },

    mixins: [Notify],

    methods: {
        relatorio() {      
            this.$router.push({ name: 'motoristasGastoRead' })
        },

        carros() {
            this.$router.push({ name: 'motoristasCarroRead' })
        },

        postos() {
            this.$router.push({ name: 'motoristasPostoRead' })
        }
    },
};
</script>
